<template>
    <div class="content-about-text">{{ text }}</div>
</template>
<script>
export default {
    name: 'ContentAboutText',
    props: {
        text: String
    }
}
</script>